<fluent-button (click)="toggleWorkbookTabs()">Toggle Tabs</fluent-button>
